<template>
  <div>
    <LoadingSkeleton v-if="loading" />
    <div v-else>
      <h4 v-if="!userClients || !userClients.length" class="no-projects">
        <b>No projects just yet...</b>
      </h4>
      <div>
        <b-row v-if="userClients && userClients.length">
          <b-col md="12">
            <b-row md="12" class="mb-24 float-right">
              <b-col sm="6">
                <i
                  class="i-Letter-Open"
                  :class="!calendarViewSelected ? 'view-selected' : ''"
                  @click="toggleView"
                ></i
              ></b-col>
              <b-col sm="6"
                ><i
                  class="i-Calendar-4"
                  :class="calendarViewSelected ? 'view-selected' : ''"
                  @click="toggleView"
                ></i>
              </b-col>
            </b-row>
          </b-col>
          <b-row v-if="!onHomePage" class="overdue"> </b-row>
          <b-col md="12">
            <b-card class="project-calendar">
              <!-- <Calendar
                v-show="calendarViewSelected"
                key="calendar"
                v-model="clientLists"
                :restrict-to-user-id="user.id"
                :colour-by-project="true"
              /> -->
              <div v-show="!calendarViewSelected" key="list">
                <div class="master-row align-right">
                  <b-button
                    :variant="
                      `${showShortTermTasks ? 'outline-' : ''}dark btn-sm`
                    "
                    @click="toggleShowShortTermTasks"
                    >{{ showShortTermTasks ? "Hide" : "Show" }} Long Term
                    Tasks</b-button
                  >
                  <b-button
                    class="toggle-button-gap"
                    :variant="
                      `${hideCompletedTasks ? '' : 'outline-'}dark btn-sm`
                    "
                    @click="toggleHideCompletedTasks"
                    >{{ hideCompletedTasks ? "Show" : "Hide" }} Completed
                    Tasks</b-button
                  >
                  <b-button
                    class="toggle-button-gap"
                    :variant="`${hideHoldTasks ? '' : 'outline-'}dark btn-sm`"
                    @click="togglehideHoldTasks"
                    >{{ hideHoldTasks ? "Show" : "Hide" }} On Hold Items
                    (<strong>{{ onHoldCount }}</strong
                    >)</b-button
                  >
                  <b-button
                    v-if="false"
                    class="toggle-button-gap"
                    :variant="
                      `${
                        collapseAllProjects.toggle ? '' : 'outline-'
                      }dark btn-sm`
                    "
                    @click="togglecollapseAllProjects"
                    >{{
                      collapseAllProjects.toggle ? "Reveal" : "Collapse"
                    }}
                    All</b-button
                  >
                </div>
                <div v-for="client in userClients" :key="client.id">
                  <template v-if="showOrHideClient(client)">
                    <b-col md="7">
                      <h3
                        v-if="true"
                        class="project-title"
                        @click="$router.push(`/Client/${client.id}`)"
                      >
                        {{ client.name }}
                      </h3>
                      <h3
                        v-else
                        class="project-title"
                        @click="changeProjectVisibility(client)"
                      >
                        {{ client.name }}
                      </h3>
                      <h6 class="project-title-grey">
                        {{ hourCountPerStatus(client.id) }}
                      </h6>
                      <div style="display: block">
                        Support Hours -
                        <h6 class="time-text">
                          Allocated:
                          {{ getAllocatedHours(client.id) }}
                        </h6>
                        •
                        <h6 class="time-text">
                          Remaining:
                          {{ getRemainingHours(client.id) }}
                        </h6>
                      </div>
                    </b-col>
                    <b-collapse
                      :ref="`projectDropDown${client.id}`"
                      :visible="true"
                    >
                      <template v-if="showTasks">
                        <List
                          v-for="(list, index) in getLists(client)"
                          :key="list.id"
                          v-model="getLists(client)[index]"
                          :state="state"
                          class="ml-15"
                          @remove-list="removeList"
                          @update-task="updateTask"
                          @update-list="updateList"
                          @item-moved="onListShuffled"
                        />
                      </template>
                      <TicketList
                        v-if="showTickets(client)"
                        ref="ticketList"
                        v-model="client.tickets"
                        :state="state"
                        class="ml-15"
                        :fixed="true"
                        @update-ticket="updateTicket"
                        @update-list="updateList"
                        @item-moved="onListShuffled"
                        @dragging-started="notifyOtherListsOfDragging(true)"
                        @dragging-stopped="notifyOtherListsOfDragging(false)"
                      />
                    </b-collapse>
                    <hr />
                  </template>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex"
// const Calendar = () => import("@/components/calendar")
import List from "@/components/project/projectlist/list"
import TicketList from "@/components/project/projectlist/ticketList"
import LoadingSkeleton from "./loadSkeleton"

export default {
  components: {
    // Calendar,
    List,
    LoadingSkeleton,
    TicketList
  },
  props: {
    user: {
      type: Object,
      default: null
    },
    state: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      projectListsProxy: [],
      blurredProjects: [],
      loading: true,
      constrcuting: false,
      calendarViewSelected: false,
      updateTimer: null,
      userProjects: null,
      shortTerm: new Date(+new Date() + 12096e5)
    }
  },
  apollo: {
    userClients: {
      query: require("@/graphql/Client/GetUserClients.gql"),
      variables() {
        return {
          userId: this.user.id
        }
      },
      skip() {
        return !this.user?.id
      },
      fetchPolicy: "no-cache",
      update(data) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.loading = false
          })
        }, 0)
        return data.userClients
      }
    },
    timelogClients: {
      query: require("@/graphql/Client/GetClientsTimelogsLW.gql"),
      fetchPolicy: "no-cache",
      update(data) {
        return data
      }
    }
  },
  computed: {
    ...mapState({
      hideCompletedTasks: state => state.taskcontrol.hideCompletedTasks,
      hideHoldTasks: state => state.taskcontrol.hideHoldTasks,
      showShortTermTasks: state => state.taskcontrol.showShortTermTasks
    }),
    allTasks() {
      return (
        [].concat(
          ...[]
            .concat(
              ...this.userClients.map(x => x.sections).filter(x => x.length)
            )
            ?.map(x => x?.tasks.filter(x => !x.completed))
        ) ?? []
      )
    },
    allTickets() {
      return (
        [].concat(
          ...this.userClients
            ?.map(x => x.tickets)
            ?.map(x => x?.tasks.filter(x => !x.completed))
            .filter(x => x?.length)
        ) ?? []
      )
    },
    onHoldCount() {
      if (!this.userClients) return
      var onHoldTasks =
        this.allTasks.filter(x => x.status == "On Hold").length ?? 0
      var onholdTickets =
        this.allTickets.filter(x => x.status == "On Hold").length ?? 0

      return (onHoldTasks || 0) + (onholdTickets || 0)
    },
    onHomePage() {
      return this.$route.name == "Overview"
    },
    currentLeave() {
      const currentLeave = this.user.upcomingLeave?.find(
        x => new Date(x.from) <= new Date()
      )
      if (!currentLeave) return null
      return {
        ...currentLeave,
        to: this.$moment(this.$utils.addDays(currentLeave.to, 1)).format(
          "YYYY/MM/DD"
        ),
        daysLeft: Math.round(
          Math.abs(
            (new Date(currentLeave.to) - new Date()) / (24 * 60 * 60 * 1000)
          )
        )
      }
    },
    futureLeave() {
      const nextWeek = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() + 7
      )
      const futureLeave = this.user.upcomingLeave?.find(
        x => new Date(x.from) <= nextWeek
      )
      if (!futureLeave) return null
      return {
        ...futureLeave,
        daysUntil: Math.round(
          Math.abs(
            (new Date(futureLeave.from) - new Date()) / (24 * 60 * 60 * 1000)
          )
        )
      }
    },
    overdueCount() {
      if (!this.userClients) return
      var overdueTasks =
        this.allTasks.filter(x => new Date(x.end) <= this.yesterday).length ?? 0
      var overdueTickets =
        this.allTickets.filter(x => new Date(x.end) <= this.yesterday).length ??
        0
      return overdueTasks + overdueTickets
    },
    yesterday() {
      return new Date(new Date().setDate(new Date().getDate() - 1))
    },
    showTasks() {
      return this.state !== "Tickets"
    }
  },
  created() {
    //Make sure that all project lists arent collapsed
    this.setCollapseAllLists(false)
  },
  methods: {
    ...mapMutations({
      toggleHideCompletedTasks: "togglehideCompletedTasks",
      togglehideHoldTasks: "togglehideHoldTasks",
      toggleShowShortTermTasks: "toggleShowShortTermTasks",
      togglecollapse: "togglecollapseAllProjects",
      toggleSingleProject: "toggleSingleProject",
      setCollapseAllLists: "setcollapseAll"
    }),
    ...mapActions({ updateProject: "projects/updateProjectLists" }),
    /**
     * Updates list
     * @param list
     * @returns {Promise<void>}
     */
    async updateList(list) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Section/UpdateSection.gql"),
        variables: {
          section: list
        }
      })
    },
    /**
     * Updates task
     * @param task
     * @returns {Promise<void>}
     */
    async updateTask(task) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Task/UpdateTask.gql"),
        variables: {
          task: task
        }
      })
    },
    allClientTasks(clientId) {
      return (
        [].concat(
          ...[]
            .concat(
              ...this.userClients?.map(x => x.sections).filter(x => x.length)
            )
            .filter(x => x?.clientId == clientId)
            ?.map(x => x?.tasks.filter(x => !x.completed))
        ) ?? []
      )
    },
    allClientTickets(clientId) {
      return (
        [].concat(
          ...this.userClients
            ?.map(x => x.tickets)
            .filter(x => x?.clientId == clientId)
            ?.map(x => x?.tasks.filter(x => !x.completed))
            .filter(x => x?.length)
        ) ?? []
      )
    },
    countPerStatus(clientId) {
      const onHoldTaskCnt = this.allClientTasks(clientId)?.filter(
        x => x.status == "On Hold"
      )
      const onHoldTickCnt = this.allClientTickets(clientId)?.filter(
        x => x.status == "On Hold"
      )

      const waitingOnClientTaskCnt = this.allClientTasks(clientId)?.filter(
        x => x.status == "Waiting On Client"
      )
      const waitingOnClientTickCnt = this.allClientTickets(clientId)?.filter(
        x => x.status == "Waiting On Client"
      )
      const pendingReleaseTaskCnt = this.allClientTasks(clientId)?.filter(
        x => x.status == "Pending Release"
      )
      const pendingReleaseTickCnt = this.allClientTickets(clientId)?.filter(
        x => x.status == "Pending Release"
      )
      const needsSchedulingTaskCnt = this.allClientTasks(clientId)?.filter(
        x => x.status == "Needs Scheduling"
      )
      const needsSchedulingTickCnt = this.allClientTickets(clientId)?.filter(
        x => x.status == "Needs Scheduling"
      )
      const releasedToTestTaskCnt = this.allClientTasks(clientId)?.filter(
        x => x.status == "Released To Test"
      )
      const releasedToTestTickCnt = this.allClientTickets(clientId)?.filter(
        x => x.status == "Released To Test"
      )

      const status =
        " - On Hold: " +
        (onHoldTaskCnt.length + onHoldTickCnt.length) +
        " • Waiting On Client: " +
        (waitingOnClientTaskCnt.length + waitingOnClientTickCnt.length) +
        " • Pending Release: " +
        (pendingReleaseTaskCnt.length + pendingReleaseTickCnt.length) +
        " • Needs Scheduling: " +
        (needsSchedulingTaskCnt.length + needsSchedulingTickCnt.length) +
        " • Released To Test: " +
        (releasedToTestTaskCnt.length + releasedToTestTickCnt.length)

      return status
    },
    hourCountPerStatus(clientId) {
      const tmpTickets = this.allClientTickets(clientId)
      const tmpTasks = this.allClientTasks(clientId)

      const onHoldHoursTaskCnt = this.totalTaskHours(tmpTasks, "On Hold")

      const onHoldHoursTickCnt = this.totalTicketHours(tmpTickets, "On Hold")

      const waitingOnClientHoursTaskCnt = this.totalTaskHours(
        tmpTasks,
        "Waiting On Client"
      )

      const waitingOnClientHoursTickCnt = this.totalTicketHours(
        tmpTickets,
        "Waiting On Client"
      )

      const pendingReleaseHoursTaskCnt = this.totalTaskHours(
        tmpTasks,
        "Pending Release"
      )
      const pendingReleaseHoursTickCnt = this.totalTicketHours(
        tmpTickets,
        "Pending Release"
      )

      const needsSchedulingHoursTaskCnt = this.totalTaskHours(
        tmpTasks,
        "Needs Scheduling"
      )
      const needsSchedulingHoursTickCnt = this.totalTicketHours(
        tmpTickets,
        "Needs Scheduling"
      )

      const scheduledHoursTaskCnt = this.totalTaskHours(tmpTasks, "Scheduled")

      const scheduledHoursTickCnt = this.totalTicketHours(
        tmpTickets,
        "Scheduled"
      )

      const status =
        " - On Hold: " +
        (onHoldHoursTaskCnt + onHoldHoursTickCnt) +
        " • Waiting On Client: " +
        (waitingOnClientHoursTaskCnt + waitingOnClientHoursTickCnt) +
        " • Pending Release: " +
        (pendingReleaseHoursTaskCnt + pendingReleaseHoursTickCnt) +
        " • Needs Scheduling: " +
        (needsSchedulingHoursTaskCnt + needsSchedulingHoursTickCnt) +
        " • Scheduled: " +
        (scheduledHoursTaskCnt + scheduledHoursTickCnt)

      return status
    },
    totalTicketHours(ticketList, statusName) {
      var toReduce =
        ticketList
          ?.filter(x => x?.hours && x?.status == statusName)
          ?.map(x => x?.hours) ?? []
      if (!toReduce.length || toReduce.length <= 0) return 0
      //Reduce new array of all task hours
      let totalHours =
        (toReduce?.reduce(
          (accumulator, currentValue) =>
            parseFloat(accumulator) + parseFloat(currentValue)
        ) ??
          0) ||
        0

      if (!totalHours) return 0

      //Issue where value is a string when total hours is initially 0
      if (typeof totalHours == "string") totalHours = Number(totalHours)

      let final = totalHours

      if (final == "0.00") return 0

      return final
    },
    totalTaskHours(taskList, statusName) {
      const incompleteTasks =
        taskList.filter(x => x?.hours && x?.status == statusName) ?? []
      if (!incompleteTasks.length || incompleteTasks.length <= 0) {
        return 0
      }
      //Reduce new array of all task hours
      let totalHours =
        (incompleteTasks
          .map(x => x?.hours)
          ?.reduce(
            (accumulator, currentValue) =>
              parseFloat(accumulator) + parseFloat(currentValue)
          ) ??
          0) ||
        0
      if (!totalHours) return 0

      //Issue where value is a string when total hours is initially 0
      if (typeof totalHours == "string") totalHours = Number(totalHours)

      let final = totalHours

      if (final == "0.00") return 0

      return final
    },
    /**
     * Gets the remaining Billable hours for client
     * @param client
     * @returns {number}
     */
    getRemainingHours(clientId) {
      let client = this.timelogClients?.clients?.filter(
        x => x?.id == clientId
      )[0]
      let total = 0
      if (!client?.timeLogs?.some(x => x)) total = client?.supportTime
      else
        client?.timeLogs.forEach(c => {
          total +=
            (c.type === "Billable" || c.type === "Unsure") && c.support
              ? c.time
              : 0 || 0
        })

      total = client?.supportTime - total
      total = parseFloat(total.toFixed(2))

      return total
    },
    getOtherHours(clientId) {
      let client = this.timelogClients?.clients?.filter(
        x => x?.id == clientId
      )[0]

      let total = 0

      if (!client?.timeLogs?.some(x => x)) return total
      else
        client.timeLogs.forEach(c => {
          total += (!c.support ? c.time : 0) || 0
        })

      return parseFloat(total.toFixed(2))
    },
    getAllocatedHours(clientId) {
      let client = this.timelogClients?.clients?.filter(
        x => x?.id == clientId
      )[0]

      return client?.supportTime
    },
    /**
     * Updates ticket
     * @param ticket
     * @returns {Promise<void>}
     */
    async updateTicket(ticket) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Ticket/UpdateTicket.gql"),
        variables: {
          ticket: ticket
        }
      })
    },
    /**
     * Checks whether or not to show tickets for this client.
     * @param client
     * @returns {boolean|boolean}
     */
    showTickets(client) {
      return (
        client?.tickets?.tasks?.some(
          x => !this.hideHoldTasks || x.status != "On Hold"
        ) && this.state !== "Tasks"
      )
    },
    getWaitTime(userClients) {
      return (
        [].concat(
          ...[]
            .concat(...userClients.map(x => x.sections).filter(x => x.length))
            ?.map(x => x?.tasks.filter(x => !x.completed))
        ).length ??
        0 +
          [].concat(
            ...userClients
              ?.map(x => x.tickets)
              ?.map(x => x?.tasks)
              .filter(x => x?.length)
          ).length ??
        0
      )
    },
    /**
     *
     * @param id
     * @returns {*}
     */
    checkProjectsVisibility({ id }) {
      var found = this.collapseAllProjects.projects.find(x => x && x.id === id)
      return found ? found.visible : !this.collapseAllProjects.toggle
    },
    /**
     *
     * @param project
     */
    changeProjectVisibility(project) {
      project.visible = !this.checkProjectsVisibility(project)
      this.toggleSingleProject({
        visible: project.visible,
        id: project.id
      })
    },
    projectListApplicableToUser(list) {
      return list.tasks?.some(
        x => !x.completed && x.users.includes(this.user.id)
      )
    },
    getTickets(client) {
      if (!this.state || this.state == "All" || this.state == "Tickets")
        return client.tickets
      if (this.state == "Overdue")
        return client.tickets?.filter(x =>
          x.tasks?.some(x => new Date(x.end) <= this.yesterday)
        )
    },
    /**
     * Gets lists based on state
     * @param client
     * @returns {*}
     */
    getLists(client) {
      if (!this.state || this.state == "All")
        return client.sections?.filter(x =>
          x.tasks?.some(
            x =>
              (!this.hideCompletedTasks || !x.completed) &&
              (!this.hideHoldTasks || x.status != "On Hold") &&
              (!this.showShortTermTasks || new Date(x.start) <= this.shortTerm)
          )
        )
      if (this.state == "Overdue")
        return client.sections?.filter(x =>
          x.tasks?.some(x => !x.completed && new Date(x.end) <= this.yesterday)
        )

      if (this.state == "Tasks")
        return client.sections?.filter(x =>
          x.tasks?.some(
            x =>
              (!x.completed && this.hideCompletedTasks) ||
              !this.hideCompletedTasks
          )
        )
    },
    /**
     * Checks whether or not to show this client based on state
     * @param client
     * @returns {boolean|*}
     */
    showOrHideClient(client) {
      //Each of these account for the STATE (all/tasks/tickets/overdue...)
      //..As well as the show/hide completed/onhold

      if (!this.state || this.state == "All")
        return (
          client.tickets?.tasks?.some(
            x => !this.hideHoldTasks || x.status != "On Hold"
          ) ||
          client.sections?.some(x =>
            x.tasks.some(
              t =>
                (!this.hideCompletedTasks || !t.completed) &&
                (!this.hideHoldTasks || t.status != "On Hold") &&
                (!this.showShortTermTasks ||
                  new Date(x.start) <= this.shortTerm)
            )
          )
        )
      if (this.state == "Overdue")
        return !!(
          client.tickets?.tasks.some(
            x =>
              new Date(x.end) <= this.yesterday &&
              (!this.hideHoldTasks || x.status != "On Hold")
          ) ||
          client.sections?.some(x =>
            x.tasks?.some(
              x =>
                ((!this.hideCompletedTasks || !x.completed) &&
                  new Date(x.end) <= this.yesterday &&
                  (!this.hideHoldTasks || x.status != "On Hold") &&
                  !this.showShortTermTasks) ||
                new Date(x.start) <= this.shortTerm
            )
          )
        )

      if (this.state == "Tickets")
        return client.tickets?.tasks?.some(
          t =>
            (!this.hideCompletedTasks || !t.completed) &&
            (!this.hideHoldTasks || t.status != "On Hold") &&
            (!this.showShortTermTasks || new Date(t.start) <= this.shortTerm)
        )
      if (this.state == "Tasks")
        return client.sections?.some(x =>
          x.tasks?.some(
            x =>
              (!this.hideCompletedTasks || !x.completed) &&
              (!this.hideHoldTasks || x.status != "On Hold") &&
              (!this.showShortTermTasks || new Date(x.start) <= this.shortTerm)
          )
        )
    },
    toggleView() {
      this.calendarViewSelected = !this.calendarViewSelected
    },
    /**
     *
     * @param selections
     */
    blurCalendarEvents(selections) {
      let mappedSelections = []
      Object.keys(selections).map(function(key) {
        mappedSelections.push({
          name: key,
          blur: !selections[key]
        })
      })
      this.blurredProjects = mappedSelections
    },
    /**
     *
     * @param parameters
     * @returns {Promise<void>}
     */
    async onListShuffled(parameters) {
      //Get lists for the appropriate client
      let clientLists
      this.userClients.forEach(client => {
        if (client.sections.find(x => x.id == parameters.listFrom)) {
          clientLists = client.sections
          return
        }
      })

      var fromList = clientLists.find(list => {
        return list.id == parameters.listFrom
      })

      var toList = clientLists.find(list => {
        return list.id == parameters.listTo
      })

      let task = fromList.tasks.find(x => x.id == parameters.taskId)
      if (toList) {
        //false if deleted
        //Add task to new list
        // toList.tasks.unshift(task)
        task.sectionId = toList.id
      } else {
        //remove task from previous list
        this.lodash.remove(fromList.tasks, task => {
          return task.id === parameters.taskId
        })
        return await this.deleteTask({
          description: task.description,
          completed: task.completed,
          hours: task.hours,
          statusId: task.statusId,
          priority: task.priority,
          start: task.start,
          end: task.end,
          id: task.id,
          number: task.number,
          users: task.users.map(x => x.id),
          sectionId: task.sectionId,
          deleted: true
        })
      }
      //Just updating the sectionId for this task
      await this.updateTask({
        description: task.description,
        completed: task.completed,
        hours: task.hours,
        statusId: task.statusId,
        priority: task.priority,
        start: task.start,
        end: task.end,
        id: task.id,
        number: task.number,
        users: task.users?.map(x => x.id),
        sectionId: task.sectionId
      })
    },
    /**
     *
     * @param list
     */
    removeList(list) {
      //Remove list from client lists
      this.userClients.forEach(client => {
        client.sections = client.sections?.filter(x => x.id != list.id)
      })
      // this.lodash.remove(
      //   this.userClients.map(x => x.sections),
      //   sections => {
      //     return sections?.find(x => x.id === list.id)
      //   }
      // )
      //For some reason it isnt updating automatically so..
      this.$forceUpdate()
    },
    togglecollapseAllProjects() {
      this.togglecollapse(this.userClients)
    },
    /**
     * Deletes the task
     * @param task
     * @returns {Promise<void>}
     */
    async deleteTask(task) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Task/DeleteTask.gql"),
        variables: {
          task: task
        }
      })
    }
  }
}
</script>
<style scoped>
.project-progress,
.project-calendar,
.view-toggle,
.pie-chart {
  margin-bottom: 10px;
}
.progress-container {
  margin-bottom: 1.5rem;
}
.progress-container:last-child {
  margin-bottom: 0 !important;
}
.no-projects {
  text-align: center;
  margin-top: 50px;
  color: grey;
}
.view-toggle {
  text-align: center;
}
.view-toggle i:hover {
  cursor: pointer;
  border: 0.5px solid #003473;
  padding: 10px;
  border-radius: 50%;
}
.view-selected {
  border: 1px solid #003473;
  padding: 10px;
  border-radius: 50%;
  background-color: #003473;
  color: white;
}
.master-row {
  border-radius: 4px;
  margin-bottom: 5px;
  float: right;
}
.project-title {
  display: inline-block;
  cursor: pointer;
}

.time-text {
  margin-right: 4px;
  margin-left: 4px;
  display: inline-block;
}

.project-title-grey {
  display: inline-block;
  margin-left: 10px;
  color: rgb(186, 186, 186);
}

.toggle-button-gap {
  margin-left: 0.25rem;
}

.large {
  font-size: 0.8rem;
}

.overdue {
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.leave-bubble {
  margin-left: 1rem;
}
</style>
